module.exports = __webpack_public_path__ + "static/media/sort-alpha-up.2aa1b8bb.svg";